(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertyVouchers', PropertyVouchers);

    PropertyVouchers.$inject = ['$resource'];

    function PropertyVouchers ($resource) {
        var service = $resource('api/property/:id/vouchers', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
